var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route !== '/spaceship' && _vm.route !== '/passworld' && !_vm.$store.getters.isFocusedOnStuff)?_c('div',{staticClass:"hud"},[_c('div',{staticClass:"content"},[_c('p',[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm.storedPlace)+" ")]):_vm._e(),(
          _vm.route !== '/passworld' &&
            _vm.route !== '/main-hall' &&
            _vm.route !== '/spaceship'
        )?_c('span',{staticClass:"back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("| GO BACK")]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }